import { Box, Divider, Grid, Paper, Typography } from '@material-ui/core';
import { opTypesNames } from '../constants/datatypes';
import { moneyFormat, simpleDateFormatter } from '../Shared/colorFormat';
import useAccounts from '../hooks/useAccounts';
// import { eventStatusShort } from '../Sections/constants/datatypes';
import { LinkLocation } from '../common';
import { ImageView } from '../components/viewer';
import ItemsTableView from './ItemsTableView';
import { useTemplate } from '../hooks';
import KaidsTable from './KaidsTable';

const DocumentView = ({ document, isRTL, words }: any) => {
  const {
    docNo,
    opType,
    time,
    title,
    desc,
    contractName,
    contractNameAr,
    startDate,
    endDate,
    // status,
    locationLink,
    address,
    customerName,
    customerNameAr,
    custmerPhone,
    supplierName,
    supplierNameAr,
    supplierPhone,
    accountName,
    accountNameAr,
    departmentName,
    departmentNameAr,
    employeeName,
    employeeNameAr,
    resourseName,
    resourseNameAr,
    debitAcc,
    creditAcc,
    total,
    discount,
    amount,
    paymentType,
    refNo,
    chequeBank,
    chequeNo,
    chequeDate,
    attachments,
    manualDocNo,
    manualRefNo,
    items,
    kaids,
  } = document;
  const { accounts } = useAccounts();
  const { tempwords } = useTemplate();

  const documentName = isRTL
    ? opTypesNames?.[opType]?.nameAr
    : opTypesNames?.[opType]?.name;

  const debit = accounts?.find((x: any) => x.code === debitAcc);
  const credit = accounts?.find((x: any) => x.code === creditAcc);
  // const statusobj = eventStatusShort?.find((x: any) => x.value === status);

  const rattachments = attachments ? JSON.parse(attachments) : [];
  let fitems = items;
  let fkaids = kaids;

  if (items && items?.length > 0) {
    fitems = items.map((item: any, i: any) => {
      return {
        ...item,
        index: i,
        name: item.itemName,
        nameAr: item.itemNameAr,
        itemprice: item.itemPrice,
        itemqty: item.qty,
        itemtotal: item.total,
      };
    });
  }

  if (kaids && kaids?.length > 0) {
    fkaids = kaids.map((item: any, i: any) => {
      return {
        ...item,
        index: i,
        amountDebit: item.debit,
        amountCredit: item.credit,
        acc: item.accCode,
      };
    });
  }

  return (
    <Paper style={{ width: 960, minHeight: 1355 }}>
      <Grid container spacing={2} style={{ padding: 20 }}>
        <Grid item xs={12}>
          <Box
            style={{
              display: 'flex',
              alignItems: 'center',
              flex: 1,
              height: 50,
            }}
          >
            <Typography
              style={{ fontWeight: 'bold', textAlign: 'center', fontSize: 20 }}
            >
              {documentName}
            </Typography>
            <Typography
              style={{
                fontWeight: 'bold',
                textAlign: 'center',
                fontSize: 20,
                paddingLeft: 10,
                paddingRight: 10,
              }}
            >
              {docNo}
            </Typography>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>

        <Grid item xs={6}>
          <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
            {isRTL ? 'التاريخ' : 'Date'}
          </Typography>
          <Typography style={{ paddingLeft: 20 }}>
            {simpleDateFormatter(time)}
          </Typography>
        </Grid>
        {customerName && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'العميل' : 'Customer'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? customerNameAr : customerName}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{custmerPhone}</Typography>
          </Grid>
        )}
        {supplierName && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'المورد' : 'Supplier'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? supplierNameAr : supplierName}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{supplierPhone}</Typography>
          </Grid>
        )}
        {title && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'العنوان' : 'Title'}
            </Typography>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {title}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}></Grid>
        {startDate && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'تاريخ البداية' : 'Start Date'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {simpleDateFormatter(startDate)}
            </Typography>
          </Grid>
        )}
        {endDate && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'تاريخ النهاية' : 'End Date'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {simpleDateFormatter(endDate)}
            </Typography>
          </Grid>
        )}
        {/* {statusobj?.nameAr && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'الحالة' : 'Status'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? statusobj?.nameAr : statusobj?.name}
            </Typography>
          </Grid>
        )} */}
        {manualDocNo && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'رقم الوثيقة' : 'Manual Doc No'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{manualDocNo}</Typography>
          </Grid>
        )}
        {manualRefNo && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'رقم المرجع' : 'Manual Ref No'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{manualRefNo}</Typography>
          </Grid>
        )}
        {contractName && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'العقد' : 'Contract'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? contractNameAr : contractName}
            </Typography>
          </Grid>
        )}

        {accountName && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'الحساب' : 'Account'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? accountNameAr : accountName}
            </Typography>
          </Grid>
        )}
        {departmentName && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'القسم' : 'Department'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? departmentNameAr : departmentName}
            </Typography>
          </Grid>
        )}
        {employeeName && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'الموظف' : 'Employee'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? employeeNameAr : employeeName}
            </Typography>
          </Grid>
        )}
        {resourseName && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {tempwords?.resourse}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? resourseNameAr : resourseName}
            </Typography>
          </Grid>
        )}

        <Grid item xs={12}></Grid>
        {paymentType && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'طريقة الدفع' : 'Payment Type'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{paymentType}</Typography>
          </Grid>
        )}
        {refNo && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'المرجع' : 'Ref No'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{refNo}</Typography>
          </Grid>
        )}
        {fitems && fitems?.length > 0 && (
          <ItemsTableView
            rows={fitems}
            isRTL={isRTL}
            words={words}
          ></ItemsTableView>
        )}
        {total && !!discount && (
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'المجموع' : 'Total'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{total}</Typography>
          </Grid>
        )}
        {!!discount && (
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'الخصم' : 'Discount'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{discount}</Typography>
          </Grid>
        )}
        {amount && (
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'الإجمالي' : 'Amount'}
            </Typography>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {moneyFormat(amount)}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}></Grid>
        {debitAcc && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'حساب الدائن' : 'Debit Account'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? debit?.nameAr : debit?.name}
            </Typography>
          </Grid>
        )}
        {creditAcc && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'حساب المدين' : 'Credit Account'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {isRTL ? credit?.nameAr : credit?.name}
            </Typography>
          </Grid>
        )}

        {fkaids && fkaids?.length > 0 && (
          <KaidsTable
            rows={fkaids}
            isRTL={isRTL}
            words={words}
            accounts={accounts}
          ></KaidsTable>
        )}

        {chequeBank && (
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'البنك' : 'Bank'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{chequeBank}</Typography>
          </Grid>
        )}
        {chequeNo && (
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'رقم الشيك' : 'Cheque No'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{chequeNo}</Typography>
          </Grid>
        )}
        {chequeDate && (
          <Grid item xs={4}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'تاريخ الشيك' : 'Cheque Date'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>
              {simpleDateFormatter(chequeDate)}
            </Typography>
          </Grid>
        )}
        {rattachments && rattachments?.length > 0 && (
          <Grid item xs={12}>
            <ImageView
              images={rattachments}
              height={200}
              width={400}
            ></ImageView>
          </Grid>
        )}

        {locationLink && (
          <Grid item xs={6}>
            <LinkLocation isRTL={isRTL} value={locationLink}></LinkLocation>
          </Grid>
        )}
        {address && (
          <Grid item xs={6}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {isRTL ? 'العنوان' : 'Address'}
            </Typography>
            <Typography style={{ paddingLeft: 20 }}>{address}</Typography>
          </Grid>
        )}
        {desc && (
          <Grid item xs={12}>
            <Typography style={{ fontWeight: 'bold', paddingLeft: 20 }}>
              {desc}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Paper>
  );
};

export default DocumentView;
